<template>
  <table style="margin-top: -10px;">
    <tbody>
      <tr>
        <td width="100"><v-switch :label="cab ? 'CAB' : 'EAN13'" v-model="cab"></v-switch></td>
        <td width="100"></td>
        <td width="200"><v-switch :label="repart ? 'Répartition' : 'Stock'" v-model="repart"></v-switch></td>
      </tr>
    </tbody>
  </table>

    
    <table style="margin-top: -30px">
      <v-progress-linear v-if="waiting" color="antiquewhite" indeterminate></v-progress-linear>
      <v-sheet :elevation="10"   >
        <tbody>
          <tr>
            <th width="100">Image</th>
            <th>Nom Appel</th>
            <th>Réf fourn</th>
            <th>Désignation</th>
            <th>Collection</th>
            <th>Répart</th>
            <th>Dépot</th>
            <th>Mag</th>
            <th>Prix</th>
          </tr>
          <tr>
            <td width="100" class="iconplus" @click="dialog = true">
              <v-icon class="iconplus" icon="mdi-plus"></v-icon>
            </td>
            <td>{{ premier.reference_y2 }}</td>
            <td>
              <input type="text" style="text-align:center" :value="premier.ref_fourn"
                    @change="modifierFiche('ref_fourn', $event.target.value)" />
            </td>
            <td>
              <input type="text" style="text-align:center" :value="premier.designation"
                    @change="modifierFiche('designation', $event.target.value)" />
            </td>
            <td>
              <select ref="selectCollection" :value="premier.collection" @change="demanderCollection($event.target.value)">
                <option v-for="key in collections" :key="key" :value="key">{{ key }}</option>
              </select>
            </td>
            <td class="iconplus" @click="repartDialog = true">
              <v-icon class="iconplus" icon="mdi-plus"></v-icon>
            </td>
            <td>{{ stockDepot }}</td>
            <td>{{ stockMagasins }}</td>
            <td>€<input ref="inputPrix" type="text" size="5"
                  :value="prixAffiche"
                  @input="$event.target.value = $event.target.value.replace(',', '.').match(/^\d*\.?\d{0,2}/)?.[0] || ''"
                  @change="demanderPrix($event.target.value)" />
            </td>
          </tr>
          <tr>
            <td width="100" class="iconrefresh" @click="rafraichir()">
              <v-icon color="primary" class="iconrefresh" icon="mdi-refresh"></v-icon>
            </td>
            <td colspan="20" style="text-align:left">
              <v-chip size="x-small" @click="ouvrirDimensions()">{{ premier.dimension }}</v-chip>
              <v-chip size="x-small" @click="ouvrirDimensions()">{{ Number(premier.poidsnet).toFixed(3) }} Kg</v-chip>
              <v-chip v-if="premier.volume" size="x-small" @click="ouvrirDimensions()">{{ Number(premier.volume).toFixed(3) }} L</v-chip>
              <span :style="{ color: typesPromo === 'PBG' ? 'blue' : 'red', marginLeft: '10px' }">{{ periodProperties }}</span>
            </td>
            <td colspan="20"></td>
          </tr>
          <tr>
            <td rowspan="30" width="100" valign="top">
              <img style="margin: 1px; border: 0.1em solid lightgrey; max-width: 200px; cursor: pointer;" width="100%"
                  :src="imageAffichee" :alt="premier.reference_y2" loading="lazy" @click="ouvrirPopUpPhotos()">
              <v-btn
                color="primary"
                v-if="isChanged.promo || isChanged.prixBase || isChanged.fiche"
                :loading="enregistrement"
                @click="validerPromo()"
                size="large" rounded="0" variant="text" density="compact">
                Valider
              </v-btn>
            </td>
            <td colspan="20">
              <table style="margin: 1px;">
                <tbody class="tableArticle">
                  <tr style="border-bottom: 0.1em solid; border-color: lightgrey;">
                    <th width="90">couleur</th>
                    <th width="40">taille</th>
                    <th width="60">Prix</th>
                    <th width="50" v-if="!visiblefunction && !visible">Promo</th>
                    <th width="40" v-if="visiblefunction || visible">Remise</th>
                    <th width="60" v-if="visiblefunction || visible">Type</th>
                    <th width="50" v-if="visiblefunction || visible">Promo</th>
                    <th width="50">Collec.</th>
                    <th class="filiale" @click="getReliquat()" title="Afficher les compteurs de la référence">Info</th>
                    <th width="40" class="filiale" v-for="el in ETAB.depot" :key="el"><span>{{ el }}</span></th>
                    <th width="40" class="filiale" v-if="!ETAB.depot.includes(store.state.etablissement)">
                      <span>{{ store.state.etablissement }}</span>
                    </th>
                    <template v-for="g in GROUPES" :key="g.cle">
                      <th width="50" class="filiale" @click="basculerGroupe(g.cle)"><span>{{ g.libelle }}</span></th>
                      <template v-if="colOuverte === g.cle">
                        <th class="etabclass" v-for="el in g.etabs.filter(e => e != store.state.etablissement)" :key="el">{{ el }}</th>
                      </template>
                    </template>
                  </tr>
                  <Color
                    v-for="article in couleursTriees"
                    :key="article.codebarre"
                    :article
                    :col
                    :cab
                    :repart
                    v-model="visible"
                    :visiblefunction
                    @isChangedCol="value => { isChanged = value }"
                    @photo_name="name => { photo_name = name }"
                  ></Color>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </v-sheet>
    </table>
    

  <Repartition v-if="repartDialog" :article="premier" v-model="repartDialog" :articleRepart="{ type: 'ref' }"></Repartition>

  <!-- Fiche article -->
  <v-dialog v-model="dialog" max-width="600">
    <v-card title="Fiche Article">
      <v-card-text>
        <v-row dense>
          <v-col cols="12" md="4" sm="6">
            <v-text-field label="Acheteur" v-model="acheteur" density="compact" variant="outlined"></v-text-field>
          </v-col>
          <v-col cols="12" md="4" sm="6">
            <v-text-field label="Pôle" v-model="pole" density="compact" variant="outlined"></v-text-field>
          </v-col>
          <v-col cols="12" md="4" sm="6">
            <v-text-field label="Code douanier" v-model="douanier" density="compact" variant="outlined"></v-text-field>
          </v-col>
          <v-col cols="12" md="4" sm="6">
            <v-combobox label="Composition" :items="store.state.composition" v-model="composition"
                        variant="outlined" density="compact"
                        @dblclick="addData('products-statistics/v1/1/values', 'statisticId', '1')"></v-combobox>
          </v-col>
          <v-col cols="12" md="4" sm="6">
            <v-text-field label="Pays" v-model="pays" density="compact" variant="outlined"></v-text-field>
          </v-col>
          <v-col cols="12" md="4" sm="6">
            <v-text-field label="Fournisseur" v-model="fournisseur" density="compact" variant="outlined"></v-text-field>
          </v-col>
          <v-col cols="12" md="4" sm="6">
            <v-combobox label="Code Thème" :items="themesDeLaMarque" v-model="codeTheme"
                        variant="outlined" density="compact"
                        @dblclick="addData('products-user-defined-tables/v1/1/values', 'tableId', '2')"></v-combobox>
          </v-col>
          <v-col cols="12" md="4" sm="6">
            <v-combobox label="Code marque" :items="store.state.marques" v-model="codemarque"
                        variant="outlined" density="compact"
                        @dblclick="addData('products-user-defined-tables/v1/1/values', 'tableId', '1')"></v-combobox>
          </v-col>
          <v-col cols="12" md="4" sm="6">
            <v-text-field label="Prix Achat" v-model="PrixAchat" density="compact" variant="outlined"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6" sm="6">
            <v-btn color="red" v-if="promoActuelle.cond" :loading="suppressionEnCours" @click="demanderSuppressionPromo()">
              Supprimer promo
            </v-btn>
          </v-col>
        </v-row>
        <small class="text-caption text-medium-emphasis">*indicates required field</small>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text="Fermer" variant="plain" @click="dialog = false" color="red"></v-btn>
        <v-btn color="primary" text="Valider" variant="plain" @click="dialog = false"></v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!-- Confirmation de suppression de promo (affichée seulement après la réponse du serveur) -->
  <v-dialog v-model="dialogFinale" width="auto">
    <v-card max-width="400" prepend-icon="$error" :text="messageFinal" title="Suppression promo">
      <template v-slot:actions>
        <v-btn class="ms-auto" text="OK" @click="dialogFinale = false"></v-btn>
      </template>
    </v-card>
  </v-dialog>

  <v-dialog v-model="dialogSolde" width="auto">
    <v-card max-width="400" prepend-icon="$error" title="Suppression soldes"
            :text="`La référence ${premier.reference_y2} est en solde, sélectionnez les démarques à supprimer SVP !`">
      <v-row>
        <v-checkbox label="VP" v-model="demarques.vp" style="margin-left: 20%;"></v-checkbox>
        <v-checkbox label="D1" v-model="demarques.d1"></v-checkbox>
        <v-checkbox label="D2" v-model="demarques.d2"></v-checkbox>
        <v-checkbox label="D3" v-model="demarques.d3"></v-checkbox>
        <v-checkbox label="OT" v-model="demarques.ot"></v-checkbox>
      </v-row>
      <template v-slot:actions>
        <v-btn color="red" text="Annuler" @click="dialogSolde = false"></v-btn>
        <v-btn color="green" text="Valider" :loading="suppressionEnCours" @click="supprimerPromo()"></v-btn>
      </template>
    </v-card>
  </v-dialog>

  <!-- Dimensions : on modifie une copie, le store n'est changé qu'à la validation -->
  <v-dialog v-model="dialogDimensions" width="auto">
    <v-card max-width="400" prepend-icon="$error" title="Dimensions">
      <v-form v-model="dimensionsValides" @submit.prevent="validerDimensions()">
        <v-card-text>
          <v-row>
            <v-col>
              <v-text-field clearable type="text" v-model="brouillon.dimension" label="Dimensions"
                            density="compact" variant="outlined" placeholder="L*H*P"
                            :rules="[regle('Dimensions', /^\d+(?:\.\d+)?\*\d+(?:\.\d+)?(?:\*\d+(?:\.\d+)?)?$/)]">
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field clearable type="number" v-model="brouillon.poidsnet" label="Poids"
                            density="compact" variant="outlined" placeholder="0.00" prefix="Kg"
                            :rules="[regle('Poids', /^[0-9]*[.,]?[0-9]*$/)]">
              </v-text-field>
            </v-col>
            <v-col>
              <v-text-field clearable type="number" v-model="brouillon.volume" label="Volume"
                            density="compact" variant="outlined" prefix="L" placeholder="0.00"
                            :rules="[regle('Volume', /^[0-9]*[.,]?[0-9]*$/)]">
              </v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" text="Annuler" variant="plain" @click="dialogDimensions = false"></v-btn>
          <v-btn type="submit" :disabled="!dimensionsValides" :loading="enregistrement" color="green" text="Valider" variant="plain"></v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>

  <InfosQuantities v-if="qteDialog" :productData :article="premier" :storeOptions :type="{ type: 'reference' }" v-model="qteDialog">
  </InfosQuantities>

  <!-- Confirmation : prix de base ou collection appliqué à toutes les couleurs -->
  <v-dialog v-model="allColors.validation" width="auto" persistent>
    <v-card max-width="500" prepend-icon="mdi-percent"
            :title="allColors.type == 'prix' ? 'Modification prix de base' : 'Modification collection'">
      <v-card-text>
        <div v-if="allColors.type == 'prix' && !(allColors.prix > 0)">
          <p>Veuillez saisir un prix supérieur à <b>0 €</b></p>
        </div>
        <div v-if="allColors.type == 'prix' && allColors.prix > 0">
          <p>Vous êtes en train d'appliquer le prix de <b>{{ allColors.prix.toFixed(2) }} €</b> à toutes les couleurs de la référence <b>{{ allColors.reference }}</b></p>
          <p>Souhaitez-vous confirmer cette modification ?</p>
        </div>
        <div v-if="allColors.type == 'collection'">
          <p>Vous êtes en train d'appliquer la collection <b>{{ allColors.collection }}</b> à toutes les couleurs de la référence <b>{{ allColors.reference }}</b></p>
          <p>Souhaitez-vous confirmer cette modification ?</p>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn color="warning" :text="allColors.type == 'prix' && !(allColors.prix > 0) ? 'OK' : 'Non'" @click="annulerAllColors()"></v-btn>
        <v-btn v-if="allColors.type == 'collection'" :loading="enregistrement" color="green" text="Oui" @click="confirmerCollection()"></v-btn>
        <v-btn v-if="allColors.type == 'prix' && allColors.prix > 0" :loading="enregistrement" color="green" text="Oui" @click="confirmerPrix()"></v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-snackbar v-model="snackbar" :color="snackbarColor" timeout="2000" location="top">
    {{ snackbarMessage }}
    <template v-slot:actions>
      <v-btn color="white" variant="text" @click="snackbar = false">Fermer</v-btn>
    </template>
  </v-snackbar>

  <PhotosFripe v-if="popupVisible" v-model="popupVisible" :article="premier" :photosTab="photosFripe"></PhotosFripe>
  <AjoutData v-if="dialogAjoutData" v-model="dialogAjoutData" :typeDataToAdd="typeDataToAdd" :codemarque></AjoutData>
</template>

<script setup>
import { onMounted, computed, ref, watch } from 'vue'
import axios from 'axios'
import Color from './Color.vue'
import store from './store'
import Repartition from './components/Repartition.vue'
import InfosQuantities from './components/InfosQuantities.vue'
import PhotosFripe from './components/PhotosFripe.vue'
import AjoutData from './components/AjoutData.vue'
import { appelY2, decouper, etabPrix, dateFR, LIMITE_PRIX, LIMITE_STOCK } from './outils/cegid'

const props = defineProps({ references: { type: Object, required: true } })
const visible = defineModel({ default: false })

// ------------------------------------------------------------ Constantes ---
const API = 'https://my.edisac.com/api'
const COLLECTIONS = ['E23', 'E24', 'E25', 'E26', 'E27', 'H23', 'H24', 'H25', 'H26', 'H27', 'R23', 'R24', 'R25', 'R26', 'R27']
const ETAB = {
  depot: ['DEPO', 'DWEB'],
  frNord: ['DK03', 'MN01', 'EN11', 'FT04', 'LI02', 'RO06'],
  pdc: ['AR09', 'CO18', 'HB21'],
  be: ['BR08', 'NP19', 'GE22', 'OO10'],
  lc: ['LO07'],
  etrier: ['CA24', 'VX05', 'PR25'],
  reflex: ['WEDI', 'WEBE', 'WENL', 'WETR', 'WOOM', 'WCAM', 'WAMZ'],
  ad: ['DEFEC', 'DEPAD', 'LITIG', 'NEGO', 'PHOTO', 'RECEP', 'TRANS', 'NGEXT'],
}
// Ordre des colonnes de l'en-tête (doit rester le même que dans Color.vue)
const GROUPES = [
  { cle: 'edisacFranceCol', libelle: 'France', etabs: [...ETAB.frNord, ...ETAB.pdc] },
  { cle: 'edisacBelgiqueCol', libelle: 'Belgique', etabs: ETAB.be },
  { cle: 'etabLcCol', libelle: 'Longchamp', etabs: ETAB.lc },
  { cle: 'etabEtrierCol', libelle: 'Etrier', etabs: ETAB.etrier },
  { cle: 'etabReflexCol', libelle: 'Reflex', etabs: ETAB.reflex },
  { cle: 'etabADCol', libelle: 'AD', etabs: ETAB.ad },
]

// ---------------------------------------------------------- Données de base ---
const lignes = computed(() => Object.values(props.references))
const premier = computed(() => props.references[Object.keys(props.references)[0]] || {})
const couleursTriees = computed(() => Object.keys(props.references).sort().map(k => props.references[k]))
const bucket = () => store.state.articles?.[premier.value.code_marque]?.[premier.value.code_theme]?.[premier.value.reference_y2]
const position = () => ({ marque: premier.value.code_marque, theme: premier.value.code_theme, reference: premier.value.reference_y2 })

// ------------------------------------------------------------------- État ---
const cab = ref(false)
const repart = ref(false)
const dialog = ref(false)
const repartDialog = ref(false)
const dialogFinale = ref(false)
const dialogSolde = ref(false)
const dialogDimensions = ref(false)
const dialogAjoutData = ref(false)
const qteDialog = ref(false)
const popupVisible = ref(false)
const waiting = ref(false)
const enregistrement = ref(false)
const suppressionEnCours = ref(false)
const messageFinal = ref('')
const typeDataToAdd = ref('')
const productData = ref(null)
const storeOptions = ref(null)
const photosFripe = ref({ photos: [], firstPhoto: '', PhotosCount: 0 })
const demarques = ref({ vp: false, d1: false, d2: false, d3: false, ot: false })
const selectCollection = ref(null)
const inputPrix = ref(null)

const isChangedVide = () => ({ promo: false, repart: false, fiche: false, dimensions: false, prixBase: false })
const isChanged = ref(isChangedVide())

const allColors = ref({ type: '', collection: '', prix: 0, validation: false, reference: '' })

// Champs de la fiche article (fenêtre « + »)
const acheteur = ref(premier.value.acheteur)
const pole = ref(premier.value.pole)
const douanier = ref(premier.value.code_catdouanie)
const codeTheme = ref(premier.value.code_theme)
const pays = ref(premier.value.code_paysorigine)
const composition = ref(premier.value.code_composition)
const fournisseur = ref(premier.value.code_fourn)
const codemarque = ref(premier.value.code_marque)
const PrixAchat = ref('')

const themesDeLaMarque = computed(() =>
  (store.state.themes || [])
    .map(t => String(t).split('|').map(s => s.trim()))
    .filter(p => p[1] == codemarque.value)
    .map(p => p[0])
)

// ------------------------------------------------------------ Snackbar ---
const snackbar = ref(false)
const snackbarMessage = ref('')
const snackbarColor = ref('success')
function showSnackbar(message, color = 'success') {
  snackbarMessage.value = message
  snackbarColor.value = color
  snackbar.value = true
}

// ------------------------------------------------- Colonnes filiales ---
const colOuverte = ref(null)
const basculerGroupe = cle => { colOuverte.value = colOuverte.value === cle ? null : cle }
// Même forme qu'avant pour Color.vue : { edisacFranceCol: true/false, ... }
const col = computed(() => Object.fromEntries(GROUPES.map(g => [g.cle, colOuverte.value === g.cle])))

// ------------------------------------------------------- Stock / promo ---
const somme = etabs => lignes.value.reduce(
  (total, a) => total + etabs.reduce((t, e) => t + Number(a.stock?.[e] || 0), 0), 0)
const stockDepot = computed(() => somme(ETAB.depot))
const stockMagasins = computed(() => somme([...ETAB.frNord, ...ETAB.pdc, ...ETAB.be, ...ETAB.lc, ...ETAB.etrier]))

const visiblefunction = computed(() => lignes.value.some(a => a.type_promo))

const promoActuelle = computed(() => {
  const types = lignes.value.map(a => a.type_promo).filter(Boolean)
  if (!types.length) return { cond: false, type: '' }
  if (types.some(t => /sol/i.test(t))) return { cond: true, type: 'solde' }
  return { cond: true, type: types[0] }
})

// ------------------------------------------------------------- Photos ---
const photoPremier = () => ({
  couleur: `${premier.value.code_couleur} - ${premier.value.couleur}`,
  photo: premier.value.photo_name,
})
const photo_name = ref(photoPremier())
// On ne réinitialise la photo que si la référence ou sa première couleur change (plus de watch profond)
watch(() => `${Object.keys(props.references)[0]}|${premier.value.photo_name}`, () => { photo_name.value = photoPremier() })

const estFripe = computed(() => /FRI/i.test(premier.value.reference_y2 || ''))
const imageAffichee = computed(() => {
  if (photo_name.value.photo) return `https://www.edisac.com/images/article_la/${photo_name.value.photo}`
  if (/^FRI-/.test(premier.value.reference_y2 || '')) return 'https://www.edisac.com/images/photolib_la/Header-com_mb.jpg'
  return 'https://www.edisac.com/images/article_la/nopic2.gif'
})

function ouvrirPopUpPhotos() {
  if (estFripe.value) return getPhotos()
  if (!photo_name.value.photo) return
  const photos = [...new Map(
    lignes.value
      .filter(a => String(a.photo_name || '').trim())
      .map(a => [a.photo_name, { couleur: `${a.code_couleur} - ${a.couleur}`, photo: a.photo_name }])
  ).values()]
  const src = `https://www.edisac.com/images/article_la/${photo_name.value.photo}`
  photosFripe.value = {
    photos,
    firstPhoto: { couleur: photo_name.value.couleur, photo: photo_name.value.photo },
    srcImage: src,
    PhotosCount: photos.length,
    index: photos.findIndex(p => p.photo === photo_name.value.photo),
  }
  popupVisible.value = true
}

async function getPhotos() {
  try {
    const { data } = await axios.get(`${API}/photos_article_fripe`, {
      headers: { Authorization: `Bearer ${store.state.user.token}` },
      params: { codebarre: premier.value.codebarre },
    })
    if (data.PhotosCount > 0) {
      photosFripe.value = data
      popupVisible.value = true
    }
  } catch (error) {
    console.error('Photos fripe :', error.response?.status, error.message)
    showSnackbar('Impossible de charger les photos', 'error')
  }
}

function addData(url, tableId, id) {
  typeDataToAdd.value = { id, tableId, url }
  dialogAjoutData.value = true
}

// ------------------------------------------------- Enregistrement serveur ---
/** Utilisateur envoyé au serveur, sans mot de passe ni jeton. */
function utilisateur() {
  const { password, token, ...reste } = store.state.user || {}
  return reste
}

/** Envoie la référence au serveur. Renvoie true si l'enregistrement a réussi. */
async function validerArticles() {
  try {
    await axios.post(`${API}/articles`, {
      articles: { ...bucket() },
      isChanged: isChanged.value,
      user: utilisateur(),
    }, { headers: { Authorization: `Bearer ${store.state.user.token}` } })
    isChanged.value = isChangedVide()
    return true
  } catch (error) {
    console.error('validerArticles :', error.response?.status, error.message)
    showSnackbar(`Erreur : la référence ${premier.value.reference_y2} n'a pas été enregistrée`, 'error')
    return false
  }
}

async function validerPromo() {
  enregistrement.value = true
  const ok = await validerArticles()
  enregistrement.value = false
  if (ok) showSnackbar(`La référence ${premier.value.reference_y2} a été modifiée`, 'success')
}

/** Applique un champ à toutes les couleurs de la référence (mutation du store). */
function updateReference(champs, value) {
  const ref = premier.value
  for (const key in bucket()) store.commit('updateReference', { referenceCol: ref, key, data: { champs, value } })
}

function modifierFiche(champ, valeur) {
  updateReference(champ, valeur)
  isChanged.value.fiche = true // fait apparaître le bouton « Valider »
}

// --------------------------------------------- Prix de base / collection ---
const prixAffiche = computed(() => Number(premier.value.vte_euro || 0).toFixed(2))
const collections = computed(() => {
  const actuelle = premier.value.collection
  return actuelle ? [actuelle, ...COLLECTIONS.filter(c => c !== actuelle)] : COLLECTIONS
})

function demanderPrix(valeur) {
  allColors.value = {
    type: 'prix', prix: Number(valeur), collection: '', validation: true, reference: premier.value.reference_y2,
  }
}
function demanderCollection(valeur) {
  allColors.value = {
    type: 'collection', collection: valeur, prix: 0, validation: true, reference: premier.value.reference_y2,
  }
}
function annulerAllColors() {
  allColors.value.validation = false
  // On remet à l'écran les valeurs actuelles (la saisie annulée n'est pas appliquée)
  if (inputPrix.value) inputPrix.value.value = prixAffiche.value
  if (selectCollection.value) selectCollection.value.value = premier.value.collection
}

async function confirmerPrix() {
  const ref = premier.value
  const oldPrix = ref.vte_euro
  const newPrix = allColors.value.prix.toFixed(2)
  enregistrement.value = true
  store.commit('updateIsChangedCol', { key: 'prixBase', value: true })
  for (const key in bucket()) store.commit('updatePrix', { referenceCol: ref, key, prix: { oldPrix, newPrix } })
  isChanged.value.prixBase = true
  const ok = await validerArticles()
  enregistrement.value = false
  allColors.value.validation = false
  if (ok) showSnackbar(`Le prix de la référence ${ref.reference_y2} a été modifié`, 'success')
}

async function confirmerCollection() {
  enregistrement.value = true
  updateReference('collection', allColors.value.collection)
  isChanged.value.fiche = true
  const ok = await validerArticles()
  enregistrement.value = false
  allColors.value.validation = false
  if (ok) showSnackbar(`La référence ${premier.value.reference_y2} a été modifiée`, 'success')
}

// ---------------------------------------------------------- Dimensions ---
const brouillon = ref({ dimension: '', poidsnet: '', volume: '' })
const dimensionsValides = ref(true)
const regle = (libelle, regex) => v => !v || regex.test(String(v)) || `Le ${libelle} n'est pas en bon format`

function ouvrirDimensions() {
  brouillon.value = {
    dimension: premier.value.dimension ?? '',
    poidsnet: premier.value.poidsnet ?? '',
    volume: premier.value.volume ?? '',
  }
  dialogDimensions.value = true
}

async function validerDimensions() {
  if (!dimensionsValides.value) return
  for (const champ of ['dimension', 'poidsnet', 'volume']) updateReference(champ, brouillon.value[champ])
  isChanged.value.dimensions = true
  enregistrement.value = true
  const ok = await validerArticles()
  enregistrement.value = false
  if (ok) {
    dialogDimensions.value = false
    showSnackbar(`Les dimensions de la référence ${premier.value.reference_y2} ont été modifiées`, 'success')
  }
}

// ------------------------------------------------- Suppression de promo ---
function demanderSuppressionPromo() {
  if (promoActuelle.value.type === 'solde') dialogSolde.value = true
  else supprimerPromo()
}

async function supprimerPromo() {
  const d = demarques.value
  const solde = d.vp || d.d1 || d.d2 || d.d3 || d.ot
    ? { vp: d.vp && 'vp', d1: d.d1 && 'd1', d2: d.d2 && 'd2', d3: d.d3 && 'd3', ot: d.ot && 'ot' }
    : false
  const promo = [...new Set(lignes.value.map(a => a.type_promo).filter(Boolean))].join(', ')
  suppressionEnCours.value = true
  try {
    await axios.post(`${API}/deletepromo`, {
      articles: props.references, solde, user: utilisateur(),
    }, { headers: { Authorization: `Bearer ${store.state.user.token}` } })
    store.commit('deletePromo', position())
    demarques.value = { vp: false, d1: false, d2: false, d3: false, ot: false }
    dialogSolde.value = false
    messageFinal.value = `La référence ${premier.value.reference_y2} a été supprimée de la promotion ${promo}`
    dialogFinale.value = true
  } catch (error) {
    console.error('deletePromo :', error.response?.status, error.message)
    showSnackbar(`Erreur : la promotion n'a pas été supprimée`, 'error')
  } finally {
    suppressionEnCours.value = false
  }
}

// ------------------------------------------------- Prix et stock Cegid ---
const codesBarres = () => lignes.value.map(a => a.codebarre).filter(Boolean)

async function refreshPrices(etablissement, date) {
  const pos = position()
  const codes = codesBarres()
  if (!codes.length) return
  waiting.value = true

  const prix = decouper(codes, LIMITE_PRIX).map(lot =>
    appelY2(`/stores/${etablissement}/selling-prices/v1`, { taxExcluded: false, date, barcodes: lot })
      .then(({ data }) => {
        for (const p of data?.prices ?? []) {
          if (!bucket()?.[p.barcode]) continue
          const enPromo = p.unitPrice.base !== p.unitPrice.current
          store.commit('updateArticlePrice', {
            ...pos, barcode: p.barcode,
            vte_euro: p.unitPrice.base.toFixed(2),
            prix_promo: enPromo ? p.unitPrice.current.toFixed(2) : 0,
            type_promo: enPromo ? p.periodId : '',
          })
        }
      })
      .catch(e => console.error('selling-prices :', pos.reference, e.response?.status, e.message)))

  const stock = decouper(codes, LIMITE_STOCK).map(lot =>
    appelY2('/available-quantities/v1', { barcodes: lot })
      .then(({ data }) => {
        for (const entry of Object.values(data ?? {})) {
          if (!bucket()?.[entry.barcode]) continue
          const qtes = {}
          for (const s of entry.stores ?? []) qtes[s.id] = s.physicalQty
          store.commit('updateArticleStock', { ...pos, barcode: entry.barcode, stock: qtes })
        }
      })
      .catch(e => console.error('available-quantities :', pos.reference, e.response?.status, e.message)))

  await Promise.all([...prix, ...stock])
  waiting.value = false
}

const rafraichir = () => Promise.all([
  refreshPrices(etabPrix(store.state.etablissement), store.state.date),
  getRepartition(),
])

// Changement de date ou d'établissement : prix et stock de cette référence
// (tous les CodeArticle passent par la même file Cegid, limitée à 10 appels simultanés)
watch(() => [store.state.etablissement, store.state.date], ([etab, date]) => {
  if (etab && date && store.state.mode !== 'import') refreshPrices(etabPrix(etab), date)
})

// ---------------------------------------------- Période de la promotion ---
const periodProperties = ref('')
const typesPromo = computed(() => [...new Set(lignes.value.map(a => a.type_promo).filter(Boolean))].sort().join('|'))

let derniereDemande = 0
async function majPeriodePromo() {
  const demande = ++derniereDemande
  const types = typesPromo.value ? typesPromo.value.split('|') : []
  if (!types.length) { periodProperties.value = ''; return }

  const etab = etabPrix(store.state.etablissement)
  const periodes = await Promise.all(types.map(t =>
    appelY2(`/stores/${etab}/price-list-periods/v1/${encodeURIComponent(t)}`)
      .then(r => r.data)
      .catch(e => { console.error('Période promo', t, e.response?.status); return null })))
  if (demande !== derniereDemande) return // une demande plus récente a été lancée entre-temps

  const toutes = lignes.value.every(a => a.type_promo)
  periodProperties.value = periodes
    .filter(p => p?.id)
    .map(p => `${toutes ? 'Toutes les couleurs sont' : 'Uniquement ces couleurs sont'} en ${p.description} du ${dateFR(p.dateRange?.startDate)} au ${dateFR(p.dateRange?.endDate)}`)
    .join(' · ')
}
// Recalculée dès que les promos des couleurs changent (quelle que soit l'origine) ou l'établissement
watch([typesPromo, () => store.state.etablissement], majPeriodePromo, { immediate: true })

// ------------------------------------------- Compteurs / répartition ---
async function inventaire(fields) {
  const reponses = await Promise.all(decouper([...new Set(codesBarres())], LIMITE_STOCK).map(lot =>
    appelY2('/inventory-quantities/v1', { fields, barcodes: lot })))
  return reponses.flatMap(r => r.data || [])
}

function groupById(data) {
  const groupes = new Map()
  for (const item of data) {
    const id = item.id.split(/\s+/)[0]
    if (!groupes.has(id)) groupes.set(id, { id, stores: [] })
    const groupe = groupes.get(id)
    for (const s of item.stores ?? []) {
      let mag = groupe.stores.find(x => x.id === s.id)
      if (!mag) groupe.stores.push((mag = { id: s.id, warehouses: [] }))
      for (const w of s.warehouses ?? []) {
        let depot = mag.warehouses.find(x => x.id === w.id)
        if (!depot) mag.warehouses.push((depot = { id: w.id, quantities: {} }))
        for (const [cle, valeur] of Object.entries(w.quantities ?? {})) {
          if (valeur !== 0) depot.quantities[cle] = (depot.quantities[cle] || 0) + valeur
        }
      }
    }
  }
  return [...groupes.values()][0]
}

async function getReliquat() {
  try {
    const data = await inventaire('Quantities')
    if (!data.length) return showSnackbar('Aucune donnée trouvée pour cette référence', 'warning')
    productData.value = groupById(data)
    storeOptions.value = productData.value.stores.map(s => `${s.id}`)
    qteDialog.value = true
  } catch (error) {
    console.error('Compteurs :', error.response?.status, error.message)
    showSnackbar('Impossible de lire les compteurs', 'error')
  }
}

async function getRepartition() {
  try {
    const data = await inventaire('Replenishment')
    const pos = position()
    for (const entry of data) {
      if (!bucket()?.[entry.barcode]) continue
      const repartition = {}
      for (const s of entry.stores ?? []) {
        const mini = s.warehouses?.[0]?.replenishment?.minimumInventoryQuantity
        if (mini) repartition[s.id] = mini
      }
      store.commit('updateArticleRepartition', { ...pos, barcode: entry.barcode, repart: repartition })
    }
  } catch (error) {
    console.error('Répartition :', error.response?.status, error.message)
  }
}

// La répartition de tous les articles est lue par RechercheArticles après la recherche.
// Ici on la relit seulement pour cette référence : bouton rafraîchir et fermeture de la fenêtre Répartition.
// watch(repartDialog, ouverte => { if (!ouverte) getRepartition() })

onMounted(() => {
  // Référence affichée sans passer par la recherche (ex. mode import) : on lit sa répartition
  if (store.state.mode === 'import') getRepartition()
})
</script>

<style>
td {
  text-align: center;
  font-size: 10px;
}
th {
  text-align: center;
  font-size: 10px;
  background-color: antiquewhite;
}
tbody {
  font-size: 10px;
  border-collapse: separate;
  border-spacing: 5em;
}
.codebarre {
  border-top: 0.01rem solid;
  border-color: lightgrey;
}
.filiale {
  color: blue;
  cursor: pointer;
}
.filiale:hover {
  background-color: lightgrey;
}
.iconplus {
  cursor: pointer;
}
.iconplus:hover {
  background-color: antiquewhite;
}
.iconrefresh {
  cursor: pointer;
}
.iconrefresh:hover {
  background-color: rgb(164, 223, 228);
}
.tableArticle {
  border: 0.1em solid;
  border-color: lightgrey;
}
</style>